import { defineComponent as _defineComponent } from 'vue';
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withModifiers as _withModifiers, withKeys as _withKeys, withDirectives as _withDirectives, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, Transition as _Transition, unref as _unref, mergeProps as _mergeProps } from "vue";
const _hoisted_1 = { class: "chat-page" };
const _hoisted_2 = { class: "welcome-content" };
const _hoisted_3 = { class: "welcome-icon" };
const _hoisted_4 = { class: "welcome-greeting" };
const _hoisted_5 = { class: "welcome-input-wrapper" };
const _hoisted_6 = { class: "welcome-input-container" };
const _hoisted_7 = ["onKeydown"];
const _hoisted_8 = { class: "welcome-input-footer" };
const _hoisted_9 = ["disabled"];
const _hoisted_10 = { class: "suggestion-chips" };
const _hoisted_11 = ["onClick"];
const _hoisted_12 = {
    key: 0,
    class: "suggestion-dropdown"
};
const _hoisted_13 = { class: "dropdown-header" };
const _hoisted_14 = ["onClick"];
const _hoisted_15 = { class: "messages-container" };
const _hoisted_16 = {
    key: 0,
    class: "assistant-icon"
};
const _hoisted_17 = ["src"];
const _hoisted_18 = ["innerHTML"];
const _hoisted_19 = {
    key: 0,
    class: "message-row in"
};
const _hoisted_20 = { class: "assistant-icon" };
const _hoisted_21 = ["src"];
const _hoisted_22 = {
    key: 1,
    class: "followup-chips"
};
const _hoisted_23 = ["onClick"];
const _hoisted_24 = {
    key: 3,
    class: "input-wrapper"
};
const _hoisted_25 = { class: "input-row" };
const _hoisted_26 = { class: "input-container" };
const _hoisted_27 = ["onKeydown"];
const _hoisted_28 = ["disabled"];
import { ref, computed, watch, onMounted, nextTick, inject, getCurrentInstance } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '../../composables/useAppState';
import { useCustomer } from '../../composables/useCustomer';
import { useChat } from '../../composables/useChat';
import { useWhatsApp } from '../../composables/useWhatsApp';
import { useChatPanel } from '../../composables/useChatPanel';
import { processMonetaryAmounts } from '../../utils/helpers';
import SettingsOverlay from '../components/SettingsOverlay.vue';
import MgCharacter from '../components/MgCharacter.vue';
import WhatsAppEnableDrawer from '../../components/elements/WhatsAppEnableDrawer.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ChatPage',
    emits: ["colour-mode-changed"],
    setup(__props, { emit: __emit }) {
        const router = useRouter();
        const state = useAppState();
        const customerApi = useCustomer();
        const chat = useChat();
        const instance = getCurrentInstance();
        const cookies = instance?.appContext.config.globalProperties.$cookies;
        const emit = __emit;
        const registerSidebar = inject('registerSidebar');
        const updateSidebarPageItems = inject('updateSidebarPageItems');
        // Template refs
        const welcomeInput = ref(null);
        const chatInput = ref(null);
        const messagesCanvas = ref(null);
        const end = ref(null);
        const whatsAppEnableDrawer = ref(null);
        const welcomeMg = ref(null);
        const inputMg = ref(null);
        // WhatsApp composable
        const whatsAppApi = useWhatsApp({
            whatsAppPromoCard: ref(null),
            whatsAppEnableDrawer: whatsAppEnableDrawer,
            whatsAppNumber: ''
        });
        // Reactive state
        const message = ref('');
        // Message list, WhatsApp-sent tracking and PDF export shared with the mobile chat panel
        const { messages, lastWhatsAppSentIndex, hasUnsentMessages, downloadPdf } = useChatPanel({ isOpen: () => true, scrollToEnd });
        const typing = ref(false);
        const hasStartedChat = ref(false);
        const userName = ref('there');
        const openCategory = ref(null);
        const sidebarOpen = ref(false);
        const currentChatId = ref(null);
        const recentChats = ref([]);
        const colourMode = ref('dark');
        const showSettings = ref(false);
        const suggestedFollowUps = ref([]);
        const suggestRequestId = ref(0);
        const needsContextRecap = ref(false);
        // The server session has likely expired for chats reloaded from history, so the
        // first follow-up carries an inline recap of the stored conversation.
        // ponytail: raw truncated transcript, swap for an LLM-generated summary if chats get long
        function buildContextRecap() {
            const recent = messages.value.slice(-10)
                .map((m) => `${m.direction === 'out' ? 'User' : 'Assistant'}: ${String(m.body).substring(0, 300)}`)
                .join('\n');
            return `We are resuming an earlier conversation you may no longer have context for. Recap:\n"""\n${recent}\n"""\nDo not mention this recap. Reply only to the user's new message below.\n\nUser's new message: `;
        }
        function clearFollowUps() {
            suggestedFollowUps.value = [];
            suggestRequestId.value++;
        }
        // Same meta-prompt mechanism as AiChatBanner: ask the sessionless chat endpoint
        // for short follow-ups to the assistant's last reply, expecting a JSON array.
        function requestFollowUpSuggestions(assistantReply) {
            suggestedFollowUps.value = [];
            const reqId = ++suggestRequestId.value;
            console.log('FOLLOWUPS: requesting, reqId', reqId);
            chat.sendSessionlessChatMessage(`The assistant just replied to the user with: """${assistantReply}""". ` +
                `Suggest up to 3 short follow-up questions or replies the user might send next. ` +
                `Include Yes/No if the assistant's reply invites that. ` +
                `Don't include please or similar politeness markers. ` +
                `The user is in the UK: any amounts must be in GBP using £, never $ or dollars. ` +
                `Each must be under 8 words. Respond ONLY with a JSON array of strings, no prose, no markdown.`, (res) => {
                console.log('FOLLOWUPS: response for reqId', reqId, 'current', suggestRequestId.value, 'body:', res?.body);
                if (reqId !== suggestRequestId.value)
                    return;
                try {
                    const match = (res?.body ?? '').match(/\[[\s\S]*\]/);
                    if (!match) {
                        console.log('FOLLOWUPS: no JSON array found in body');
                        return;
                    }
                    const parsed = JSON.parse(match[0]);
                    if (Array.isArray(parsed)) {
                        suggestedFollowUps.value = parsed
                            .filter((s) => typeof s === 'string' && s.trim().length > 0)
                            .slice(0, 3);
                        console.log('FOLLOWUPS: showing chips', suggestedFollowUps.value);
                        scrollToEndIfFollowing();
                    }
                }
                catch (e) {
                    console.log('FOLLOWUPS: parse error', e);
                }
            });
        }
        function sendFollowUp(text) {
            if (typing.value)
                return;
            message.value = text;
            sendMessage();
        }
        const suggestionCategories = [
            {
                id: 'spending',
                label: 'Spending',
                icon: 'mdi-chart-pie',
                suggestions: [
                    'Show me my spending this month',
                    'Where am I spending the most?',
                    'Help me create a budget',
                    'What are my recurring payments?'
                ]
            },
            {
                id: 'savings',
                label: 'Savings',
                icon: 'mdi-piggy-bank',
                suggestions: [
                    'How can I save more money?',
                    'Help me set a savings goal',
                    'What should my emergency fund be?',
                    'Tips for saving on groceries'
                ]
            },
            {
                id: 'accounts',
                label: 'Accounts',
                icon: 'mdi-bank',
                suggestions: [
                    'Show me my account balances',
                    'Which accounts are linked?',
                    'Help me link a new account',
                    'What is my net worth?'
                ]
            },
            {
                id: 'benefits',
                label: 'Benefits',
                icon: 'mdi-gift',
                suggestions: [
                    'What employee benefits do I have?',
                    'How do I use my benefits?',
                    'Am I missing any benefits?',
                    'Explain salary sacrifice'
                ]
            },
            {
                id: 'vouchers',
                label: 'Vouchers',
                icon: 'mdi-ticket-percent',
                suggestions: [
                    'Find me the best voucher deals',
                    'How do cashback vouchers work?',
                    'What vouchers do I have?',
                    'Recommend vouchers for groceries'
                ]
            }
        ];
        // Computed
        const customer = computed(() => state.customer);
        const safeTop = computed(() => {
            return parseInt(cookies?.get('st') ?? 0);
        });
        const greeting = computed(() => {
            const hour = new Date().getHours();
            if (hour < 12)
                return 'Good morning';
            if (hour < 17)
                return 'Good afternoon';
            return 'Good evening';
        });
        // Thinking until the first reply text arrives, then talking while it streams
        const mgState = computed(() => {
            if (!typing.value)
                return 'idle';
            return messages.value[messages.value.length - 1]?.direction === 'out' ? 'thinking' : 'talking';
        });
        const activeCategory = computed(() => {
            return suggestionCategories.find(c => c.id === openCategory.value);
        });
        // Methods
        function loadChatsFromStorage() {
            try {
                const stored = localStorage.getItem('mg_chat_history');
                if (stored) {
                    recentChats.value = JSON.parse(stored);
                }
            }
            catch {
                recentChats.value = [];
            }
        }
        function saveChatsToStorage() {
            localStorage.setItem('mg_chat_history', JSON.stringify(recentChats.value));
        }
        function saveCurrentChat() {
            if (!currentChatId.value || messages.value.length === 0)
                return;
            const chatIndex = recentChats.value.findIndex((c) => c.id === currentChatId.value);
            if (chatIndex !== -1) {
                recentChats.value[chatIndex].messages = [...messages.value];
                saveChatsToStorage();
            }
        }
        function startNewChat() {
            saveCurrentChat();
            messages.value = [];
            lastWhatsAppSentIndex.value = 0;
            hasStartedChat.value = false;
            currentChatId.value = null;
            sidebarOpen.value = false;
            needsContextRecap.value = false;
            clearFollowUps();
            nextTick(() => {
                welcomeInput.value?.focus();
            });
        }
        function createNewChatEntry(firstMessage) {
            const title = firstMessage.length > 35
                ? firstMessage.substring(0, 35) + '...'
                : firstMessage;
            const newChat = {
                id: Date.now(),
                title: title,
                messages: []
            };
            recentChats.value.unshift(newChat);
            currentChatId.value = newChat.id;
            saveChatsToStorage();
        }
        function loadChat(chatId) {
            saveCurrentChat();
            const foundChat = recentChats.value.find((c) => c.id === chatId);
            if (foundChat) {
                currentChatId.value = chatId;
                messages.value = foundChat.messages ? [...foundChat.messages] : [];
                lastWhatsAppSentIndex.value = 0;
                hasStartedChat.value = messages.value.length > 0;
                needsContextRecap.value = messages.value.length > 0;
            }
            sidebarOpen.value = false;
            clearFollowUps();
        }
        function deleteChat(chatId) {
            const index = recentChats.value.findIndex((c) => c.id === chatId);
            if (index !== -1) {
                recentChats.value.splice(index, 1);
                saveChatsToStorage();
                if (chatId === currentChatId.value) {
                    messages.value = [];
                    lastWhatsAppSentIndex.value = 0;
                    hasStartedChat.value = false;
                    currentChatId.value = null;
                }
            }
        }
        function renameChat({ id, title }) {
            const foundChat = recentChats.value.find((c) => c.id === id);
            if (foundChat) {
                foundChat.title = title;
                saveChatsToStorage();
            }
        }
        function toggleCategory(categoryId) {
            openCategory.value = openCategory.value === categoryId ? null : categoryId;
        }
        function selectSuggestion(suggestion) {
            message.value = suggestion;
            openCategory.value = null;
            sendMessage();
        }
        function scrollToEnd() {
            nextTick(() => {
                if (end.value) {
                    end.value.scrollIntoView({ behavior: 'smooth' });
                }
            });
        }
        // Keeps new content in view only if the user is already at the bottom, so they can scroll up while a reply streams.
        // Call straight after changing messages: the DOM hasn't updated yet, so this measures the old position.
        function scrollToEndIfFollowing() {
            const el = messagesCanvas.value;
            if (el && el.scrollHeight - el.scrollTop - el.clientHeight < 80) {
                nextTick(() => { el.scrollTop = el.scrollHeight; });
            }
        }
        function sendMessage() {
            if (!message.value || message.value.trim() === '' || typing.value)
                return;
            const userMessage = message.value.trim();
            const isFirstMessage = !hasStartedChat.value;
            let outgoing = userMessage;
            if (needsContextRecap.value) {
                outgoing = buildContextRecap() + userMessage;
                needsContextRecap.value = false;
            }
            hasStartedChat.value = true;
            messages.value.push({ direction: "out", body: userMessage });
            message.value = "";
            typing.value = true;
            clearFollowUps();
            scrollToEnd();
            if (isFirstMessage) {
                createNewChatEntry(userMessage);
            }
            // Handle special commands
            if (userMessage.toLowerCase() === "litmustest") {
                router.push('/litmustestpage');
                return;
            }
            if (userMessage.toLowerCase() === "admin") {
                router.push('/admin');
                return;
            }
            let reply = null;
            chat.streamChatMessage(outgoing, (text) => {
                if (!reply) {
                    messages.value.push({ direction: "in", body: "" });
                    reply = messages.value[messages.value.length - 1];
                }
                reply.body += text;
                scrollToEndIfFollowing();
            })
                .catch((error) => console.log('CHAT: stream failed', error))
                .finally(() => {
                typing.value = false;
                if (reply) {
                    requestFollowUpSuggestions(reply.body);
                }
                else {
                    messages.value.push({ direction: "in", body: "Sorry, I can't help you with that right now." });
                }
                scrollToEndIfFollowing();
                saveCurrentChat();
            });
        }
        function formatMessage(text) {
            if (!text)
                return '';
            let html = text
                .replace(/\*\*([^*]+)\*\*/g, '<strong>$1</strong>')
                .replace(/\*([^*]+)\*/g, '<em>$1</em>');
            html = html.replace(/\[([^\]]+)\]\(([^)]+)\)/g, '<a href="$2" target="_blank" rel="noopener">$1</a>');
            html = html.replace(/(<br>)+\s*(\d+\.) /g, '<br>$2 ');
            html = html.replace(/\n\s*- /g, '<br>&bull; ');
            html = html.replace(/\n/g, '<br>');
            return html;
        }
        function applyMonetaryMask(text) {
            return processMonetaryAmounts(text);
        }
        function attach() {
            customerApi.clearCustomer();
            state.customer = null;
            customerApi.getCustomer(() => {
                if (state.customer.person.whatsAppEnabled) {
                    hasStartedChat.value = true;
                    messages.value.push({ direction: "in", body: "Check your WhatsApp!" });
                    scrollToEnd();
                    whatsAppApi.sendWhatsAppNotification("You indicated you wanted to send a document 📄  Just drop it here and we will upload and process it for you 👍", state.customer.person.mobilePhone);
                }
                else {
                    if (whatsAppEnableDrawer.value) {
                        whatsAppEnableDrawer.value.openDrawer();
                    }
                }
            }, false);
        }
        // Desktop take on useChatPanel.sendToWhatsApp: stays on the page (no wa.me redirect) and uses the enable drawer
        function saveToWhatsApp() {
            if (!state.customer)
                return;
            if (!state.customer.person.whatsAppEnabled) {
                whatsAppEnableDrawer.value?.openDrawer();
                return;
            }
            const conversation = messages.value.slice(lastWhatsAppSentIndex.value)
                .filter((m) => !m.whatsAppConfirmation)
                .map((m) => (m.direction === 'out' ? 'You' : 'MG') + ': ' + m.body)
                .join('\n');
            lastWhatsAppSentIndex.value = messages.value.length;
            messages.value.push({ direction: "in", body: "Conversation sent to your WhatsApp!", whatsAppConfirmation: true });
            scrollToEnd();
            saveCurrentChat();
            whatsAppApi.sendWhatsAppNotification('Conversation saved from MGChat:\n\n' + conversation, state.customer.person.mobilePhone ?? '');
        }
        function handleEnableWhatsApp() {
            whatsAppApi.enableWhatsApp();
        }
        function handleWhatsAppEnableDone() {
            customerApi.getCustomer(null, false);
        }
        function handleWhatsAppDrawerClosed() {
            // No-op — no promo card to reset in ChatPage
        }
        function onLoad() {
            customerApi.getCustomer(() => {
                if (state.customer?.person?.firstName) {
                    userName.value = state.customer.person.firstName;
                }
                if (state.customer && !state.customer.preferences) {
                    state.customer.preferences = {
                        dailyCurrentBalanceNotifications: false,
                        dailyCreditBalanceNotifications: false,
                        quizNotifications: false
                    };
                }
            });
        }
        function updatePref(key, value) {
            if (state.customer?.preferences) {
                state.customer.preferences[key] = value;
                customerApi.savePreferences();
            }
        }
        function selectColourMode(mode) {
            colourMode.value = mode;
            localStorage.setItem('mg_colour_mode', mode);
            emit('colour-mode-changed', mode);
        }
        // Watchers
        // Pre-flush watcher, so the welcome MG is still on screen to measure before it's swapped for the input-bar one
        watch(hasStartedChat, (val) => {
            if (val) {
                const from = welcomeMg.value?.$el?.getBoundingClientRect();
                nextTick(() => {
                    chatInput.value?.focus();
                    flyMgDown(from);
                });
            }
        });
        // The welcome MG glides down and shrinks into its seat beside the input bar when the chat starts
        function flyMgDown(from) {
            const el = inputMg.value?.$el;
            if (!from || !el || window.matchMedia('(prefers-reduced-motion: reduce)').matches)
                return;
            const to = el.getBoundingClientRect();
            const dx = from.left + from.width / 2 - (to.left + to.width / 2);
            const dy = from.top + from.height / 2 - (to.top + to.height / 2);
            el.animate([
                { transform: `translate(${dx}px, ${dy}px) scale(${from.width / to.width})` },
                { transform: 'none' }
            ], { duration: 700, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' });
        }
        watch(recentChats, (newVal) => {
            if (updateSidebarPageItems) {
                updateSidebarPageItems(newVal);
            }
        }, { deep: true });
        // Mounted
        onMounted(() => {
            loadChatsFromStorage();
            onLoad();
            const savedMode = localStorage.getItem('mg_colour_mode');
            if (savedMode) {
                colourMode.value = savedMode;
            }
            else {
                colourMode.value = 'light';
                localStorage.setItem('mg_colour_mode', 'light');
            }
            nextTick(() => {
                welcomeInput.value?.focus();
            });
            if (registerSidebar) {
                registerSidebar({
                    config: {
                        actionButton: { icon: 'mdi-plus', label: 'New chat' },
                        pageItemsTitle: 'Recents',
                        pageItemsEmptyText: 'No recent chats'
                    },
                    data: { recentChats: recentChats.value },
                    handlers: {
                        onActionClick: () => startNewChat(),
                        onPageItemClick: (id) => loadChat(id),
                        onPageItemDelete: (id) => deleteChat(id),
                        onPageItemRename: (data) => renameChat(data),
                        onOpenSettings: () => { showSettings.value = true; }
                    }
                });
                if (updateSidebarPageItems) {
                    updateSidebarPageItems(recentChats.value);
                }
            }
        });
        return (_ctx, _cache) => {
            const _component_v_icon = _resolveComponent("v-icon");
            const _component_v_list_item_title = _resolveComponent("v-list-item-title");
            const _component_v_list_item = _resolveComponent("v-list-item");
            const _component_v_list = _resolveComponent("v-list");
            const _component_v_menu = _resolveComponent("v-menu");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createElementVNode("div", {
                    class: _normalizeClass(["chat-layout", colourMode.value])
                }, [
                    _createElementVNode("div", _hoisted_1, [
                        (showSettings.value)
                            ? (_openBlock(), _createBlock(SettingsOverlay, {
                                key: 0,
                                customer: customer.value,
                                colourMode: colourMode.value,
                                safeTop: safeTop.value,
                                onClose: _cache[0] || (_cache[0] = ($event) => (showSettings.value = false)),
                                onUpdatePref: updatePref,
                                onSelectColourMode: selectColourMode
                            }, null, 8, ["customer", "colourMode", "safeTop"]))
                            : (!hasStartedChat.value)
                                ? (_openBlock(), _createElementBlock("div", {
                                    key: 1,
                                    class: _normalizeClass(["welcome-screen", { 'dropdown-open': openCategory.value }])
                                }, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createElementVNode("div", _hoisted_3, [
                                            _createVNode(MgCharacter, {
                                                ref_key: "welcomeMg",
                                                ref: welcomeMg,
                                                state: "idle",
                                                size: 64
                                            }, null, 512)
                                        ]),
                                        _createElementVNode("h1", _hoisted_4, _toDisplayString(greeting.value) + ", " + _toDisplayString(userName.value), 1)
                                    ]),
                                    _createElementVNode("div", _hoisted_5, [
                                        _createElementVNode("div", _hoisted_6, [
                                            _withDirectives(_createElementVNode("textarea", {
                                                ref_key: "welcomeInput",
                                                ref: welcomeInput,
                                                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((message).value = $event)),
                                                class: "welcome-input",
                                                placeholder: "How can I help you today?",
                                                onKeydown: _withKeys(_withModifiers(sendMessage, ["exact", "prevent"]), ["enter"]),
                                                rows: "1"
                                            }, null, 40, _hoisted_7), [
                                                [_vModelText, message.value]
                                            ]),
                                            _createElementVNode("div", _hoisted_8, [
                                                _createElementVNode("button", {
                                                    class: "attach-button",
                                                    onClick: attach
                                                }, [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[5] || (_cache[5] = [
                                                            _createTextVNode("mdi-paperclip")
                                                        ])),
                                                        _: 1
                                                    })
                                                ]),
                                                _createElementVNode("button", {
                                                    class: _normalizeClass(["send-button", { active: message.value && message.value.trim() }]),
                                                    disabled: !message.value || !message.value.trim(),
                                                    onClick: sendMessage
                                                }, [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[6] || (_cache[6] = [
                                                            _createTextVNode("mdi-arrow-up")
                                                        ])),
                                                        _: 1
                                                    })
                                                ], 10, _hoisted_9)
                                            ])
                                        ]),
                                        _createElementVNode("div", _hoisted_10, [
                                            (_openBlock(), _createElementBlock(_Fragment, null, _renderList(suggestionCategories, (cat) => {
                                                return _createElementVNode("button", {
                                                    key: cat.id,
                                                    class: _normalizeClass(["suggestion-chip", { 'is-open': openCategory.value === cat.id }]),
                                                    onClick: ($event) => (toggleCategory(cat.id))
                                                }, [
                                                    _createVNode(_component_v_icon, { size: "16" }, {
                                                        default: _withCtx(() => [
                                                            _createTextVNode(_toDisplayString(cat.icon), 1)
                                                        ]),
                                                        _: 2
                                                    }, 1024),
                                                    _createElementVNode("span", null, _toDisplayString(cat.label), 1)
                                                ], 10, _hoisted_11);
                                            }), 64))
                                        ]),
                                        _createVNode(_Transition, { name: "dropdown" }, {
                                            default: _withCtx(() => [
                                                (openCategory.value)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                                                        _createElementVNode("div", _hoisted_13, [
                                                            _createVNode(_component_v_icon, { size: "18" }, {
                                                                default: _withCtx(() => [
                                                                    _createTextVNode(_toDisplayString(activeCategory.value?.icon), 1)
                                                                ]),
                                                                _: 1
                                                            }),
                                                            _createElementVNode("span", null, _toDisplayString(activeCategory.value?.label), 1),
                                                            _createElementVNode("button", {
                                                                class: "dropdown-close",
                                                                onClick: _cache[2] || (_cache[2] = ($event) => (openCategory.value = null))
                                                            }, [
                                                                _createVNode(_component_v_icon, { size: "18" }, {
                                                                    default: _withCtx(() => _cache[7] || (_cache[7] = [
                                                                        _createTextVNode("mdi-close")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ])
                                                        ]),
                                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(activeCategory.value?.suggestions, (suggestion, index) => {
                                                            return (_openBlock(), _createElementBlock("div", {
                                                                key: index,
                                                                class: "dropdown-item",
                                                                onClick: ($event) => (selectSuggestion(suggestion))
                                                            }, _toDisplayString(suggestion), 9, _hoisted_14));
                                                        }), 128))
                                                    ]))
                                                    : _createCommentVNode("", true)
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ], 2))
                                : (_openBlock(), _createElementBlock("div", {
                                    key: 2,
                                    class: "messagesCanvas",
                                    ref_key: "messagesCanvas",
                                    ref: messagesCanvas
                                }, [
                                    _createElementVNode("div", _hoisted_15, [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(messages), (m, index) => {
                                            return (_openBlock(), _createElementBlock("div", {
                                                key: index,
                                                class: _normalizeClass(['message-row', m.direction])
                                            }, [
                                                (m.direction === 'in')
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                                        _createElementVNode("img", {
                                                            src: require('@/assets/mg.png'),
                                                            alt: "MG"
                                                        }, null, 8, _hoisted_17)
                                                    ]))
                                                    : _createCommentVNode("", true),
                                                _createElementVNode("div", {
                                                    class: _normalizeClass(['message', m.direction]),
                                                    innerHTML: formatMessage(applyMonetaryMask(m.body))
                                                }, null, 10, _hoisted_18)
                                            ], 2));
                                        }), 128)),
                                        (typing.value && _unref(messages)[_unref(messages).length - 1]?.direction === 'out')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                                _createElementVNode("div", _hoisted_20, [
                                                    _createElementVNode("img", {
                                                        src: require('@/assets/mg.png'),
                                                        alt: "MG"
                                                    }, null, 8, _hoisted_21)
                                                ]),
                                                _cache[8] || (_cache[8] = _createElementVNode("div", { class: "typing-indicator" }, [
                                                    _createElementVNode("span", { class: "dot" }),
                                                    _createElementVNode("span", { class: "dot" }),
                                                    _createElementVNode("span", { class: "dot" })
                                                ], -1))
                                            ]))
                                            : _createCommentVNode("", true),
                                        (!typing.value && suggestedFollowUps.value.length > 0)
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_22, [
                                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(suggestedFollowUps.value, (s) => {
                                                    return (_openBlock(), _createElementBlock("button", {
                                                        key: s,
                                                        class: "suggestion-chip",
                                                        onClick: ($event) => (sendFollowUp(s))
                                                    }, _toDisplayString(s), 9, _hoisted_23));
                                                }), 128))
                                            ]))
                                            : _createCommentVNode("", true)
                                    ]),
                                    _createElementVNode("div", {
                                        ref_key: "end",
                                        ref: end
                                    }, null, 512)
                                ], 512)),
                        (hasStartedChat.value && !showSettings.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_24, [
                                _createElementVNode("div", _hoisted_25, [
                                    _createVNode(MgCharacter, {
                                        ref_key: "inputMg",
                                        ref: inputMg,
                                        state: mgState.value,
                                        size: 48
                                    }, null, 8, ["state"]),
                                    _createElementVNode("div", _hoisted_26, [
                                        _withDirectives(_createElementVNode("input", {
                                            ref_key: "chatInput",
                                            ref: chatInput,
                                            "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event) => ((message).value = $event)),
                                            type: "text",
                                            class: "chat-input",
                                            placeholder: "Reply to MG...",
                                            onKeydown: _withKeys(_withModifiers(sendMessage, ["exact", "prevent"]), ["enter"])
                                        }, null, 40, _hoisted_27), [
                                            [_vModelText, message.value]
                                        ]),
                                        _createVNode(_component_v_menu, { location: "top" }, {
                                            activator: _withCtx(({ props: menuProps }) => [
                                                _createElementVNode("button", _mergeProps({ class: "attach-button" }, menuProps), [
                                                    _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                                                            _createTextVNode("mdi-plus-circle-outline")
                                                        ])),
                                                        _: 1
                                                    })
                                                ], 16)
                                            ]),
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_list, { density: "compact" }, {
                                                    default: _withCtx(() => [
                                                        _createVNode(_component_v_list_item, { onClick: attach }, {
                                                            prepend: _withCtx(() => [
                                                                _createVNode(_component_v_icon, null, {
                                                                    default: _withCtx(() => _cache[10] || (_cache[10] = [
                                                                        _createTextVNode("mdi-paperclip")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => _cache[11] || (_cache[11] = [
                                                                        _createTextVNode("Attach document")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }),
                                                        _createVNode(_component_v_list_item, {
                                                            onClick: saveToWhatsApp,
                                                            disabled: typing.value || !_unref(hasUnsentMessages)
                                                        }, {
                                                            prepend: _withCtx(() => [
                                                                _createVNode(_component_v_icon, { color: "var(--whatsapp-green)" }, {
                                                                    default: _withCtx(() => _cache[12] || (_cache[12] = [
                                                                        _createTextVNode("mdi-whatsapp")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => _cache[13] || (_cache[13] = [
                                                                        _createTextVNode("Save this chat to WhatsApp")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }, 8, ["disabled"]),
                                                        _createVNode(_component_v_list_item, {
                                                            onClick: _unref(downloadPdf),
                                                            disabled: typing.value
                                                        }, {
                                                            prepend: _withCtx(() => [
                                                                _createVNode(_component_v_icon, null, {
                                                                    default: _withCtx(() => _cache[14] || (_cache[14] = [
                                                                        _createTextVNode("mdi-file-pdf-box")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            default: _withCtx(() => [
                                                                _createVNode(_component_v_list_item_title, null, {
                                                                    default: _withCtx(() => _cache[15] || (_cache[15] = [
                                                                        _createTextVNode("Download chat as PDF")
                                                                    ])),
                                                                    _: 1
                                                                })
                                                            ]),
                                                            _: 1
                                                        }, 8, ["onClick", "disabled"])
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        }),
                                        _createElementVNode("button", {
                                            class: "attach-button",
                                            title: "Summarise briefly",
                                            onClick: _cache[4] || (_cache[4] = ($event) => (sendFollowUp('Can you summarise that briefly for me please?')))
                                        }, [
                                            _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => _cache[16] || (_cache[16] = [
                                                    _createTextVNode("mdi-text-short")
                                                ])),
                                                _: 1
                                            })
                                        ]),
                                        _createElementVNode("button", {
                                            class: _normalizeClass(["send-button", { active: message.value && message.value.trim() }]),
                                            disabled: !message.value || !message.value.trim(),
                                            onClick: sendMessage
                                        }, [
                                            _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => _cache[17] || (_cache[17] = [
                                                    _createTextVNode("mdi-arrow-up")
                                                ])),
                                                _: 1
                                            })
                                        ], 10, _hoisted_28)
                                    ])
                                ])
                            ]))
                            : _createCommentVNode("", true)
                    ])
                ], 2),
                _createVNode(WhatsAppEnableDrawer, {
                    ref_key: "whatsAppEnableDrawer",
                    ref: whatsAppEnableDrawer,
                    onEnable: handleEnableWhatsApp,
                    onDone: handleWhatsAppEnableDone,
                    onClosed: handleWhatsAppDrawerClosed
                }, null, 512)
            ], 64));
        };
    }
});
